/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { GET_CUS_RECONCILIATION, GET_CUS_RECONCILIATION_DONE, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE, GET_MONEY_STATISTICS, GET_MONEY_STATISTICS_DONE } from "./constant";

export const GetMoneyStatistics = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_MONEY_STATISTICS,
    payload,
    callback
  };
};

export const GetMoneyStatisticsDone = (data: any) => ({
  type: GET_MONEY_STATISTICS_DONE,
  payload: data
})

export const getCusReconcilation = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_CUS_RECONCILIATION,
    payload,
    callback
  };
};

export const getCusReconcilationDone = (data: any) => ({
  type: GET_CUS_RECONCILIATION_DONE,
  payload: data
})

export const getCusReconcilationPaymentStatement = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_CUS_RECONCILIATION_PAYMENT_STATEMENT,
    payload,
    callback
  };
};

export const getCusReconcilationPaymentStatementDone = (data: any) => ({
  type: GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE,
  payload: data
})

export const getCusReconcilationPaymentStatementCount = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT,
    payload,
    callback
  };
};

export const getCusReconcilationPaymentStatementCountDone = (data: any) => ({
  type: GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE,
  payload: data
})